import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AttrIndexService } from 'app/services/attr-index.service';
import { NagCategory } from 'app/services/nag.service';

export interface NagStandardModalData {
	action: 'add' | 'edit';
	placeTypeList?: PlaceType[]; // The list of place types
	countyList?: ParentCounty[];
	standard?: {
		name: string;
		parentId?: number;
		source?: string;
	};
	// isSpatial?: boolean;
	selectedCate: NagCategory;
}
export interface NagStandardModalOutput {
	name: string;
	placeTypes?: string[]; // Selected place types
	parentId?: number;
	source?: string
}
export interface PlaceType { name: string; selected: boolean; }
export interface ParentCounty {
	name: string;
	stnId: number;
}

interface SourceItem {
	label: string;
	value: 'NENA' | 'Legacy';
}
@Component({
  selector: 'app-nag-standard-modal',
  templateUrl: './nag-standard-modal.component.html',
  styleUrls: ['./nag-standard-modal.component.css']
})
export class NagStandardModalComponent implements OnInit {

	public title: string;
	public standardName: string;
	public placeTypes: PlaceType[];
	public countyList: ParentCounty[] = [];

	isSpatial: boolean;
	selectedSource: SourceItem;
	sourceList: SourceItem[] = [
		{
			label: 'NENA',
			value: 'NENA'
		},
		{
			label: 'Legacy',
			value: 'Legacy'
		}
	];
	selectedCate: NagCategory;

	showSource?: boolean;
	stDirectionName: string;

	public parentCounty: ParentCounty;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NagStandardModalData,
		public dialogRef: MatDialogRef<NagStandardModalComponent>,
		private attrIndexService: AttrIndexService
	) { }

	cancel() {
		this.dialogRef.close(null);
	}
	apply() {
		// Close modal
		const data: NagStandardModalOutput = {
			name: this.standardName,
			placeTypes: this.placeTypes ? this.placeTypes.filter((t) => t.selected).map((t) => t.name) : null,
			parentId: this.parentCounty ? this.parentCounty.stnId : null,
			source: this.selectedSource ? this.selectedSource.value : null
		};
		this.dialogRef.close(data);
	}
	ngOnInit() {
		this.placeTypes = this.data.placeTypeList;
		this.countyList = this.data.countyList || [];
		this.isSpatial = this.data.selectedCate.isSpatial;
		this.selectedCate = this.data.selectedCate;
		this.showSource = false; //!this.isSpatial && this.selectedCate.name !== this.attrIndexService.stDirectionCateName;
		this.stDirectionName = this.attrIndexService.stDirectionCateName;
		switch (this.data.action) {
			case 'add':
				this.title = 'New Standard Name';
				break;
			case 'edit':
				this.title = 'Update Standard Name';
				this.selectedSource = this.data.standard.source ? this.sourceList.find(s => {
					return s.value === this.data.standard.source || s.value === this.data.standard.source.split(' ')[0];
				}) : null;
				this.parentCounty = this.countyList.find((c) => c.stnId === this.data.standard.parentId);
		}
		if (this.data.standard) {
			this.standardName = this.data.standard.name;
		}
	}

}
